import { pathFor } from "../../http";

export const draftRoutes = {
  draft: "/drafts/v1alpha1/{id}",
  connect: "/drafts/v1alpha1/{id}/connect",
  socket: "/drafts/v1alpha1/{id}/socket",
  team: "/drafts/v1alpha1/{id}/team",
  freeze: "/drafts/v1alpha1/{id}/freeze",
  thaw: "/drafts/v1alpha1/{id}/thaw",
  retire: "/drafts/v1alpha1/{id}/retire",
  export: "/drafts/v1alpha1/{id}/export",
} as const;

export const draftPaths = {
  draft: (draftId: string) => pathFor(draftRoutes.draft, { id: draftId }),
  connect: (draftId: string) => pathFor(draftRoutes.connect, { id: draftId }),
  socket: (draftId: string) => pathFor(draftRoutes.socket, { id: draftId }),
} as const;
